import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import type { MailingFileDebtorTargetFindInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-file-debtor-target-find.dto';
import type { MailingFormInterface } from '@zaoblako/shared/modules/notification/dtos/mailing/mailing-form.dto';
import { BasisNotificationService } from '@zaoblako/web/core/services/basis/basis-notification.service';
import { ErrorService } from '@zaoblako/web/core/services/error.service';
import { FileUploaderComponent } from '@zaoblako/web/shared/components/file-uploader/file-uploader.component';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'crm-newsletter-welcome-system-excel',
  standalone: true,
  imports: [CommonModule, ButtonModule, FileUploaderComponent],
  templateUrl: './newsletter-welcome-system-excel.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NewsletterWelcomeSystemExcelComponent {
  @ViewChild('fileUpload') public fileUpload: FileUploaderComponent;

  public loading = false;
  @Input() public newsletter: MailingFormInterface;

  @Output() public next = new EventEmitter<void>();

  public constructor(
    private readonly basisNotificationService: BasisNotificationService,
    private readonly cdRef: ChangeDetectorRef,
    private readonly errorService: ErrorService
  ) {}

  public downloadClick() {
    let link = document.createElement('a');
    link.setAttribute('type', 'hidden');
    link.href = '/assets/files/newsletter.xlsx';
    link.download = 'Должники';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  public selectedFileDebtor(files: FileList) {
    if (files) {
      const formData = new FormData();
      formData.append('file', files[0], files[0].name);

      this.loading = true;
      this.cdRef.markForCheck();

      this.basisNotificationService.debtorTargetsFromExcel(formData).subscribe({
        next: (result) => {
          this.newsletter.fileDebtorTargets = result;
          this.loading = false;
          this.cdRef.markForCheck();
          this.fileUpload.fileUpload?.clear();
          this.next.emit();
        },
        error: (error: HttpErrorResponse) => {
          let str = 'Некорректно заполнены данные:';
          error.error?.validationErrors.forEach((item: MailingFileDebtorTargetFindInterface, index: number) => {
            if (item) {
              Object.keys(item).forEach((key: keyof MailingFileDebtorTargetFindInterface) => {
                if (item[key]) {
                  let char: string;
                  switch (key) {
                    case 'name': {
                      char = 'A';
                      break;
                    }
                    case 'phone': {
                      char = 'B';
                      break;
                    }
                    case 'email': {
                      char = 'C';
                      break;
                    }
                    case 'amount': {
                      char = 'D';
                      break;
                    }
                  }
                  str = str.concat(`\n- Ячейка ${char}${index + 2}: ${item[key]};`);
                }
              });
            }
          });

          this.errorService.addCustomError('Ошибка валидации', str);
          this.loading = false;
          this.cdRef.markForCheck();
          this.fileUpload.fileUpload?.clear();
        }
      });
    }
  }
}
